import { render, staticRenderFns } from "./ItemHistoryChangeTypeDate.vue?vue&type=template&id=5a2b42d9&scoped=true"
import script from "./ItemHistoryChangeTypeDate.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2b42d9",
  null
  
)

export default component.exports